export function getTextsByCategory(cards: ICard[], category: string): string[] {
  if (!Array.isArray(cards)) return []

  return cards
    .filter((card) => card?.category === category && typeof card?.text === "string" && card.text.trim() !== "")
    .map((card) => card.text as string)
}

export function countCategories(cards: ICard[], categories: string[]): { label: string; count: number }[] {
  return categories.map((category) => {
    const count = cards.filter((card) => card.category === category).length
    const label = category
    return { label, count }
  })
}

export const getFeedbackGradeCategories = (cards: ICard[]) => {
  return cards
    .filter(
      (card) =>
        card.shape === "circle" &&
        typeof card.category === "string" &&
        /l\d+$/.test(card.category)
    )
    .map((card) => ({
      category: card.category,
      owner: card.owner,
    }))
}
